<template>
    <div>

    <div class="ds-schedule-toolbar-controls flex justify-between items-center py-3 pl-7 pr-7 text-[13px]">
        <div class="flex">
            <div class="pr-3">
                <DepartmentsTree class="ds-schedule-store-selector z-[51]" />
            </div>
            <div>
                <Months />
            </div>
        </div>
    </div>
        
        <iframe
        v-if="url"
        :src="url"
        class="w-screen border-0 iframe"
        />
       <div class="flex min-h-[70vh] items-center justify-center" v-if="loading">
         <Loader />
       </div>
    </div>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref, computed, watch } from 'vue';
import dayjs from 'dayjs';
import Loader from '@/ui/Loader.vue';
import Months from '@/components/header/Months.vue'
import DepartmentsTree from '@/components/header/DepartmentsTree.vue'
import { useScheduleStore } from '@/stores/scheduleStore'
import { useExchangeStore } from '@/stores/exchangeStore';

const store = useScheduleStore()
const exchangeStore = useExchangeStore()
const url = ref<string | null>(null)
const loading = ref(false)
const currentDate = computed(() => store.currentScheduleDate)
const currentDepartment = computed(() => store.currentDepartment)
let analyticsRequest = 0


const getAnalytics = async () => {
        const request = ++analyticsRequest

        loading.value = true
        const from = dayjs(currentDate.value).startOf('month').format('YYYY-MM-DD')
        const to = dayjs(from).endOf('month').format('YYYY-MM-DD')
        const data = {
            from, 
            to, 
            department: currentDepartment.value?.id
        }
        try {
            const res = await exchangeStore.fetchMetabaseUrl(data)
            if (request !== analyticsRequest) return

            url.value = typeof res === 'string' && res.includes('http') ? res : null
        } catch {
            if (request === analyticsRequest) url.value = null
        } finally {
            if (request === analyticsRequest) loading.value = false
        }
    }

    watch([currentDepartment, currentDate], () => {
        getAnalytics()
    })

    onMounted(() => {
        if(currentDepartment.value) getAnalytics()
    })

    onBeforeUnmount(() => {
        analyticsRequest++
    })

</script>

<style scoped>
    .iframe {
        height: calc(100vh - 100px);
    }
</style>
